module.exports = new __parcel__URL__("gorilla.51f05093.svg").toString();